import React from 'react';

// Components
import { Modal as AntModal } from 'antd';
import Icon from '../Icon';

const Modal = ({ children, footer = null, ...rest }) => (
  <AntModal
    footer={footer}
    {...rest}
    centered
    closeIcon={<Icon name="close" />}
  >
    {children}
  </AntModal>
);

export default React.memo(
  Modal,
  (prevProps, nextProps) => prevProps.children === nextProps.children
);
